import React, { useEffect, useState } from "react";
import { Globe2 } from "lucide-react";
import api from "../../api";

// Where our traffic actually comes from — unique visitor IPs grouped by country, over the
// same window the traffic charts above are showing (preset days or a custom date range).
export const AdminVisitorCountries = ({ params = {}, rangeLabel = "the chosen window" }) => {
  const [d, setD] = useState(null);
  const key = JSON.stringify(params);

  useEffect(() => {
    setD(null);
    api.get("/admin/visitor-countries", { params }).then((r) => setD(r.data)).catch(() => setD(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  if (!d) return null;

  const top = (d.countries || []).slice(0, 10);
  const peak = Math.max(1, ...top.map((c) => c.count));

  return (
    <div className="bg-card border border-border rounded-2xl p-5" data-testid="admin-visitor-countries">
      <h2 className="font-bold text-foreground flex items-center gap-2">
        <Globe2 size={18} className="text-[#16a34a]" /> Visitor countries
      </h2>
      <p className="text-xs text-muted-foreground mt-0.5 mb-4">
        {d.total.toLocaleString()} unique visitors seen in {rangeLabel}, by country (best-effort, from IP).
      </p>
      {top.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="visitor-countries-empty">No visitor data in this range yet.</p>
      ) : (
        <div className="space-y-2" data-testid="visitor-countries-list">
          {top.map((c) => (
            <div key={c.country} className="flex items-center gap-3" data-testid={`visitor-row-${c.country}`}>
              <span className="w-40 shrink-0 text-sm font-semibold text-foreground truncate">{c.country}</span>
              <div className="flex-1 h-2.5 rounded-full bg-secondary overflow-hidden">
                <div className="h-full rounded-full bg-[#16a34a]" style={{ width: `${(c.count / peak) * 100}%` }} />
              </div>
              <span className="w-14 text-right text-sm font-bold text-foreground tabular-nums">{c.count.toLocaleString()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminVisitorCountries;
